// extracted by mini-css-extract-plugin
module.exports = {"links":"Legal_links__Y_cod","links__column":"Legal_links__column__Va2T1","link":"Legal_link__Cy_ip","link__column":"Legal_link__column__gLiLo"};